import * as R from 'ramda'
import { getTransportationFromDepartureCities } from 'domain/filters'
import { isActionOneOfTypes, isActionType } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { InitialState, State } from './filters.types'

export const initialState: InitialState = {
  areFiltersInitialized: false,
  departureDateFlexibility: 0,
  departureDateOffset: null,
  hasDepartureDateFlexibilityBeenUsed: false,
  haveBeenOpenedByUser: false,
  isPending: false,
  products: {},
  selectedFilters: {
    departureCities: [],
    departureDates: [],
    durations: []
  },
  selectedTransportation: 'all'
}

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionType(Actions.filters.FILTERS_FETCHED),
    ({ payload: { products } }) => R.merge(state, {
      areFiltersInitialized: true,
      isPending: false,
      products: products.reduce((acc, value) => {
        acc[value.key] = value
        return acc
      }, {})
    })
  ], [
    isActionType(Actions.catalog.FILTER_CATALOG),
    () => R.assoc('haveBeenOpenedByUser', true, state)
  ], [
    isActionType(Actions.filters.SELECT_FILTERS),
    ({ payload: { selectedFilters } }) => R.merge(state, {
      selectedFilters: {
        departureCities: selectedFilters.departureCities,
        departureDates: R.map(dates => parseInt(dates, 10), selectedFilters.departureDates),
        durations: R.map(dates => parseInt(dates, 10), selectedFilters.durations)
      },
      selectedTransportation: selectedFilters.departureCities.length > 0 ? getTransportationFromDepartureCities(selectedFilters.departureCities) : state.selectedTransportation
    }, {})
  ], [
    isActionType(Actions.filters.FETCH_FILTERS_STARTED),
    () => R.assoc('isPending', true, state)
  ], [
    isActionType(Actions.filters.INIT_FILTERS),
    ({ payload: { departureCities, departureDates, durations, transportation } }) => {
      const [departureDateOffset, departureDateFlexibility] = departureDates

      return (
        R.merge(state, {
          departureDateFlexibility: R.defaultTo(0, departureDateFlexibility),
          hasDepartureDateFlexibilityBeenUsed: (departureDateFlexibility > 0),
          selectedFilters: {
            departureCities,
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            departureDates: departureDateOffset ? departureDates : [],
            durations
          },
          selectedTransportation: transportation ?? getTransportationFromDepartureCities(departureCities)
        })
      )
    }
  ], [
    isActionOneOfTypes([Actions.filters.RESET_FILTERS, Actions.application.SALE_CHANGES]),
    () => R.merge(state, {
      areFiltersInitialized: false,
      departureDateFlexibility: 0,
      departureDateOffset: null,
      hasDepartureDateFlexibilityBeenUsed: false,
      haveBeenOpenedByUser: false,
      products: {},
      selectedFilters: {
        departureCities: [],
        departureDates: [],
        durations: []
      },
      selectedTransportation: state.selectedTransportation
    })
  ], [
    isActionType(Actions.filters.SELECT_DEPARTURE_FLEXIBILITY),
    ({ payload }) => R.merge(state, {
      departureDateFlexibility: payload.departureDateFlexibility,
      hasDepartureDateFlexibilityBeenUsed: true
    })
  ], [
    isActionType(Actions.filters.SELECT_DEPARTURE_DATE_OFFSET),
    ({ payload }) => R.assoc('departureDateOffset', (
      (payload.departureDateOffset === state.departureDateOffset)
        ? null
        : payload.departureDateOffset
    ), state)
  ], [
    isActionType(Actions.filters.RESET_DEPARTURE_DATE_OFFSET),
    ({ payload }) => R.assoc('departureDateOffset', null, state)
  ], [
    isActionType(Actions.filters.RESET_DEPARTURE_DATE_FLEXIBILITY),
    ({ payload }) => R.assoc('departureDateFlexibility', (
      (state.selectedFilters.departureDates.length > 1)
        ? state.selectedFilters.departureDates[1]
        : 0
    ), state)
  ], [
    isActionType(Actions.filters.RESET_DEPARTURE_FILTERS_SETTINGS),
    ({ payload }) => R.merge(state, {
      departureDateFlexibility: 0,
      departureDateOffset: null,
      hasDepartureDateFlexibilityBeenUsed: false
    })
  ], [
    isActionType(Actions.filters.ON_FILTERED_PACKAGES_FETCHED_SUCCESS),
    ({ payload }) => {
      const productKey = payload.productKey
      const packages = payload.packages

      return state.products[productKey] !== undefined
        ? R.assocPath(['products', productKey, 'packages'], packages, state)
        : state
    }
  ], [
    isActionType(Actions.filters.SELECT_TRANSPORTATION),
    ({ payload: { selectedTransportation } }) => R.merge(state, {
      selectedFilters: {
        ...state.selectedFilters,
        departureCities: []
      },
      selectedTransportation
    }, {})
  ], [
    R.T,
    R.always(state)
  ]
])(action)
